import Immutable from 'immutable'

const error = (state = null, action) => {
  switch (action.type) {
    case 'error':
      return Immutable.fromJS(action.data.message)
    case 'reset':
      return null
    default:
      return state
  }
}

// eslint-disable-next-line import/prefer-default-export
export { error }
